export const AGENTIC_OPERATION_KEYS = [
  "planning",
  "regulatory",
  "coordination",
  "delivery",
  "growth",
  "communications",
] as const;

export type AgenticOperationKey = (typeof AGENTIC_OPERATION_KEYS)[number];
